module.exports = __webpack_public_path__ + "img/2.c5b28336.png";